import { render, staticRenderFns } from "./AttributeBuilder.vue?vue&type=template&id=2b950830&"
import script from "./AttributeBuilder.vue?vue&type=script&lang=js&"
export * from "./AttributeBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports